import { render, staticRenderFns } from "./MonsterImmunities.vue?vue&type=template&id=35477b8e&scoped=true&"
import script from "./MonsterImmunities.vue?vue&type=script&lang=ts&"
export * from "./MonsterImmunities.vue?vue&type=script&lang=ts&"
import style0 from "./MonsterImmunities.vue?vue&type=style&index=0&id=35477b8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35477b8e",
  null
  
)

export default component.exports